module.exports = __webpack_public_path__ + "img/Website_Logo.4c089d0f.png";